import { authClient } from "@platform/auth/client";

export function TenantIdentity() {
	const { data: tenant } = authClient.useActiveOrganization();
	if (!tenant) return null;

	return (
		<section className="flex flex-col gap-1">
			<h1 className="text-2xl font-semibold">{tenant.name}</h1>
			<p className="text-muted-foreground text-sm">{tenant.slug}</p>
		</section>
	);
}
